import { Link } from "react-router-dom";
import { Truck, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-slate-300">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-sm bg-brand text-white">
              <Truck className="h-6 w-6" />
            </span>
            <span className="font-heading text-xl font-bold tracking-tight text-white">
              SB Logistik
            </span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            Professionelle, fleksible og pålidelige transportløsninger til
            virksomheder i hele Danmark.
          </p>
        </div>

        {/* Navigation */}
        <div>
          <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-white">
            Navigation
          </h4>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link data-testid="footer-nav-home" to="/" className="text-slate-400 transition-colors hover:text-white">Forside</Link></li>
            <li><Link data-testid="footer-nav-services" to="/ydelser" className="text-slate-400 transition-colors hover:text-white">Ydelser</Link></li>
            <li><Link data-testid="footer-nav-about" to="/om-os" className="text-slate-400 transition-colors hover:text-white">Om os</Link></li>
            <li><Link data-testid="footer-nav-contact" to="/kontakt" className="text-slate-400 transition-colors hover:text-white">Kontakt</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-white">
            Kontakt
          </h4>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
              <span className="text-slate-400">Kløvervej 144, 3. th<br />6100 Haderslev<br />CVR: 46603206</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 shrink-0 text-brand" />
              <a
                data-testid="footer-email-link"
                href="mailto:info@sb-logistik.dk"
                className="font-medium text-white transition-colors hover:text-brand"
              >
                info@sb-logistik.dk
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 shrink-0 text-brand" />
              <span data-testid="footer-phone-text" className="text-slate-400">+45 31 81 80 44</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="mx-auto max-w-7xl px-6 py-6 text-center text-xs text-slate-500">
          © {new Date().getFullYear()} SB Logistik · CVR: 46603206 · Alle rettigheder forbeholdes.
        </div>
      </div>
    </footer>
  );
}
